<template>
  <div style="width: 80%; margin: 0 auto">
    <v-form ref="form" v-model="valid" lazy-validation>
      <simple-wizard-new @setup="setup" @toCourse="toCourse">
        <template slot="header">
          <h4 class="title">
            {{this.$route.query.type == 'edit' ? '编辑课程' : '新建课程' }}
          </h4>
        </template>

        <wizard-tab-new>
          <template slot="label"> 基础信息 </template>
          <div style="width: 100%">
            <div  class="loigWrap">
              <div class="picture-container">
                <div class="picture">
                  <!-- https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/avatar/dev/18e52881a930428b2ae1679875740cc5/%C3%A5%C2%BE%C2%AE%C3%A4%C2%BF%C2%A1%C3%A5%C2%9B%C2%BE%C3%A7%C2%89%C2%87_20211209133610.jpg -->
                  <!-- <div v-if="user.hasOwnProperty('avatar')&&JSON.stringify(user)!=='{}'"> -->
                  <!-- <img src="" class="picture-src" title="" /> -->
                  <img
                    class="picture-src"
                    :src="(logImg == ''||logImg == undefined) ? LocalscoureImg : logImg"
                  />
                  {{logImg}}
                  <!-- </div> -->
                  <!-- <div v-else>
                                <img :src="require('/public/img/faces/avatar.jpg')" />
                            </div> -->
                  <input type="file" @change="upload" />
                </div>
                <p class="logTitle">选择封面</p>
              </div>
               <p style="color: red; text-indent: 22px" class="logintitle">
                推荐课程封面尺寸为190(高)*340(宽)的封面图片
              </p>
            </div>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>

            <div class="inputWrap">
              <v-text-field
                v-model="form.name"
                label="课程名称 *"
                :rules="[v => !!v || '课程名称不能为空']"
                class="courseName"
              ></v-text-field>
              <v-select
                v-model="form.sectionType"
                :items="sectionType"
                item-text="name"
                item-value="value"
                label="课程组织形式 *"
                class="Curriculum"
              ></v-select>

              <v-textarea
                v-model="form.description"
                label="课程简介"
                rows="1"
                auto-grow
                :rules="[v => !!v || '课程简介不能为空']"
                class="courseIntroduction"
              ></v-textarea>
              <!-- <v-text-field
                v-model="form.courseDevReference"
                label="课程开发参考"
                :rules="[v => !!v || '课程开发参考不能为空']"
                class="courseName"
              ></v-text-field> -->
              <!-- <v-textarea
                v-model="form.attachments"
                label="相关资料"
                rows="1"
                auto-grow
                readonly
                @mouseup.native.stop="focusAttachment"
                class="uploadprofile"
              ></v-textarea> -->
              <div style="width: 100">
                <span style="float: left"> 是否公开课程：</span
                ><md-switch class="switchWrap" v-model="form.is_open"></md-switch>
              </div>
                <div style="width: 100">
                <span style="float: left"> 高级模式：</span><md-switch class="switchWrap" style="padding-left:28px;" v-model="form.is_senior"></md-switch>
              </div>
              <div style="font-size:13px;">
              (添加课程时默认为普通模式，高级模式课程任务编辑器里增加规则定义、自定义动作功能，同时3D编辑器里增加元件定义、规则定义功能)
              </div>
            </div>
          </div>
        </wizard-tab-new>

        <wizard-tab-new>
          <template slot="label"> 课程分类 </template>
          <div>
            <v-select
              v-model="form.refer"
              :items="refer_list"
              item-text="name"
              item-value="value"
              label="适用"
              class="Usecourse"
              :rules="[v => !!v || '适用不能为空']"
            ></v-select>
            <v-select
              v-model="form.majorGroup"
              :items="majorGroupList"
              item-text="name"
              item-value="code"
              label="专业大类"
              :rules="[v => !!v || '专业大类不能为空']"
            ></v-select>
            <v-select
              v-model="form.majorGroup2"
              :items="majorGroup2List"
              item-text="name"
              item-value="code"
              label="专业类"
              :rules="[v => !!v || '专业类不能为空']"
            ></v-select>
            <v-select
              v-model="form.major"
              :items="majorList"
              item-text="name"
              item-value="code"
              label="专业"
              :rules="[v => !!v || '专业不能为空']"
            ></v-select>
            <v-spacer></v-spacer>
          </div>
        </wizard-tab-new>

        <wizard-tab-new>
          <template slot="label"> 主持单位 </template>
          <div>
            <v-text-field
              v-model="form.university"
              label="主持单位(学校/集团)"
              :rules="[v => !!v || '主持单位(学校/集团)']"
            ></v-text-field>
            <v-text-field
              v-model="form.college"
              label="二级单位(学院/公司)"
              :rules="[v => !!v || '二级单位(学院/公司)不能为空']"
            ></v-text-field>
            <v-text-field
              v-model="form.team"
              label="教研团队"
              :rules="[v => !!v || '教研团队不能为空']"
            ></v-text-field>
            <v-text-field
              v-model="form.manager"
              label="负责人 *"
              :rules="[v => !!v || '负责人不能为空']"
              hint="请负责人先注册为系统用户，并输入负责人的系统用户名"
            ></v-text-field>
          </div>
        </wizard-tab-new>

        <!-- <template slot="footer">
          <div style="overflow: hidden; width: 100%">
            <md-card-actions md-alignment="right">
              <md-button class="md-success md-sm" @click="submit" type="submit">确定</md-button>
              <md-button class="md-success md-sm" @click="toCourse">返回</md-button>
            </md-card-actions>
          </div>
        </template> -->
      </simple-wizard-new>
    </v-form>

    <ResourceLibrarySelect
      :dialogEdit.sync="showSelectDialog"
      :checkMod="resourceList"
      @handleCancel="handleSelectCancel"
      @handleSubmit="handleSelectSubmit"
    />
  </div>
</template>

<script>
import { addCourse, updateCourse } from '@/api/course';

import { SlideYDownTransition } from 'vue2-transitions';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import ResourceLibrarySelect from '@/components/Resource/ResourceLibrarySelect';
extend('required', required);
import { ossUpload } from '@/api/common';
import { upload, userInfo } from '@/api/user';
import { getCourseById } from '@/api/course';
import { SimpleWizardNew, WizardTabNew } from '@/components';

export default {
  //mixins: [validationMixin],
  components: {
    SlideYDownTransition,
    ResourceLibrarySelect,
    SimpleWizardNew,
    WizardTabNew,
  },
  data() {
    return {
      LocalscoureImg: require('/public/img/log.png'),
      logImg: '',
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      valid: true,
      name: '',

      select: null,

      tab: null,

      panel: 0,
      sectionType: [
        { value: 'zj', name: '章节' },
        { value: 'xm', name: '项目' },
        { value: 'qj', name: '情境' },
      ],
      refer_list: [
        // { value: 'bjrs', name: '毕节人社' },
        { value: 'bk', name: '本科' },
        { value: 'gz', name: '高职' },
        { value: 'zz', name: '中职' },
        { value: 'gj', name: '技师学院' },
        { value: 'jx', name: '技校' },
        { value: 'qy', name: '企业' },
      ],
      majorGroupList: [],
      majorGroup2List: [],
      majorList: [],
      form: {
        sectionType:'zj',
        required: '',
        name: '',
        university: '',
        college: '',
        refer: '',
        major: '',
        majorGroup: '',
        majorGroup2: '',
        team: '',
        manager: '',
        attachment_url: [],
        attachments: '',
        description: '',
        is_open: false,
        is_senior:false,
        sourse_image: '',
        // courseDevReference:''//课程开发参考
      },
      // 资源弹窗
      showSelectDialog: false,
      resourceList: [],
      tabIndex:1,
    };
  },
  watch: {
    'form.refer'() {
      const refer = Array.isArray(this.form.refer) ? this.form.refer.join(',') : this.form.refer;
      if (!refer) return;
      this.majorGroupList = [];
      this.majorGroup2List = [];
      this.majorList = [];
      this.$dic.getCategoryList(
        {
          cate_type: refer,
          level: '1',
        },
        data => {
          this.majorGroupList = data;
        }
      );
    },
    'form.majorGroup'() {
      if (!this.form.majorGroup) return;
      this.majorGroup2List = [];
      this.majorList = [];
      this.$dic.getCategoryList(
        {
          cate_type: this.form.refer,
          parentCode: this.form.majorGroup,
          level: '2',
        },
        data => {
          this.majorGroup2List = data;
        }
      );
    },
    'form.majorGroup2'() {
      if (!this.form.majorGroup2) return;
      this.majorList = [];
      this.$dic.getCategoryList(
        {
          cate_type: this.form.refer,
          parentCode: this.form.majorGroup2,
          level: '3',
        },
        data => {
          this.majorList = data;
        }
      );
    },
  },
  mounted() {
    this.init();
    let that = this;
    that.$EventBus.$on('unfoldS', function (data) {
      that.panel = data;
    });

   let timer  = setTimeout(()=>{
     let designIdMenu = document.getElementById('designIdMenu');
    if(designIdMenu){
      if(window.location.pathname=='/newcourse'){
        let designIdMenu = document.getElementById('designIdMenu');
        designIdMenu.style.cssText =
            'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
      }else{
        designIdMenu.style.cssText =''
      }
      clearTimeout(timer)
	 }
    },400)
  },


  methods: {
    resetform() {
      this.$refs.form.validate();
    },
    setup(tabIndex) {
      if (tabIndex == 1) {
        this.tabIndex =tabIndex
      } else if (tabIndex == 2) {
        this.tabIndex =tabIndex
      } else if (tabIndex == 3) {
        this.tabIndex =tabIndex
        console.log('第3步确认');
        this.submit();
      }
    },
    upload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = e => {
        // this.user.avatar = e.target.result;
      };
      reader.readAsDataURL(file);
      let type = file.type.split('/') && file.type.split('/')[1] ? file.type.split('/')[1] : '';
      if (!['jpeg', 'jpg', 'png'].includes(type)) {
        this.$message.warning('请选择正确的图片格式');
        return;
      }
      let formData = new FormData();
      formData.append('avatar', file);
      upload(formData).then(res => {
        if (res.code === '200') {
          this.logImg = res.data.url;
          this.form.sourse_image = res.data.url;
        }
      });
    },
    async httpRequest(param, type) {
      this.getImgs(param, type);
    },
    handleSuccess(file, fileList, type) {
      // this.getImgs(file, type);
    },

    async getImgs(param, type = null) {
      let courseFaceUrl = await ossUpload({ path: type, file: param.file });
      if (courseFaceUrl && courseFaceUrl.url) {
        let obj = {
          name: '',
          url: courseFaceUrl.url,
        };
        this.fileList.push(obj);
        this.form.sourse_image = courseFaceUrl.url;
      }
    },

    /**
     * 上传文件
     */
    handleRemove(uploadFile, uploadFiles, type) {
      this.fileList = [];
    },
    handleAvatarSuccess(response, file, fileList) {
      console.log(response, file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    async init() {
      //回显课程封面图
      // if (this.$route.params.name) {
      //   this.form = this.$route.params;
      //   if (this.$route.params && this.$route.params.sourse_image) {
      //     this.logImg = this.$route.params.sourse_image;
      //   }
      // }
    let params = {
       courseId:this.$route.query.courseId
    }
     let _this = this;
      getCourseById(params.courseId).then(res => {
        _this.form = res.data
        this.logImg = res.data.sourse_image;
      })

   // if (this.$route.params.name) {
   //   this.form = this.$route.params;
   //   console.log(this.form)
   //   if (this.$route.params && this.$route.params.sourse_image) {
   //     this.logImg = this.$route.params.sourse_image;
   //   }
   // }
    },
    async submit() {
      let siRule = this.$refs.form.validate();
      if (!siRule) {
        this.$notify({
          timeout: 1500,
          message: '请填写必填项',
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'bottom',
          type: 'warning',
        });

        return;
      }

      const result = this.form._id;
      let res = null;
      if (this.form._id) {
        if (this.form.hasOwnProperty('refer') && this.form['refer'].length <= 0) {
          this.form['refer'] = '';
          return;
        }
        if (
          this.form.hasOwnProperty('refer') &&
          Object.prototype.toString.call(this.form['refer']) === '[object Array]' &&
          this.form['refer'].length > 0
        ) {
          this.form['refer'] = this.form['refer'][0];
        }
        res = await updateCourse(this.form);
      } else {
        if (this.form.hasOwnProperty('refer') && this.form['refer'].length <= 0) {
          this.form['refer'] = '';
          this.$notify({
            timeout: 1500,
            message: '请填写课程分类信息!',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'warning',
          });

          return;
        }
      
      this.form.createUserId = this.getUser().userId
        res = await addCourse(this.form);
      }
      if (res) {
        this.$notify({
          timeout: 1500,
          message: '操作成功！',
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'bottom',
          type: 'success',
        });
        window.localStorage.setItem('courseTab','1')
        this.$router.push({path:'./design'})
      }
    },

    getUser(){
      if(window.localStorage.getItem('USER_INFO')){
            let userData =  JSON.parse(window.localStorage.getItem('USER_INFO'))
            if(userData&&userData.user){
                return {
                   userId:userData.user._id
                }
            }
      }

    },

   async toCourse() {

        this.$router.push({path:'./design'})

    },

    //资源弹窗
    focusAttachment() {
      this.showSelectDialog = true;
      // 解决第一次弹窗闪屏问题
      setTimeout(() => {
        this.showSelectDialog = true;
      }, 100);
      this.resourceList = this.form.attachment_url;
    },
    handleSelectSubmit(checkList) {
      console.log(checkList);
      this.resourceList = checkList;
      this.form.attachment_url = checkList.map(item => {
        return {
          _id: item._id,
          name: item.name,
        };
      });
      this.form.attachments = checkList.map(item => item.name).join(',');
      this.showSelectDialog = false;
    },

    handleSelectCancel() {
      this.showSelectDialog = false;
    },
  },
};
</script>

<style lang="css" scoped>
/deep/ .md-card {
  margin: 0px !important;
}

/deep/ form .md-card {
  margin-top: 0px !important;
}

.md-checked >>> .md-switch-container {
  background: #4caf50 !important;
}
/* .switchWrap >>> .md-switch-container{
  background: #4caf50 !important;
} */
.switchHightWrap{
  margin-left: 10px;
}
.md-checked >>> .md-switch-container .md-switch-thumb {
  border: 1px solid #4caf50 !important;
}
.scoureImg {
  width: 340px;
  height: 190px;
}

.scoureImgWrap {
  margin-top: 10px;
  margin-bottom: 20px;
}
.tabTitle {
  font-size: 18px;
}

.el-upload-list {
  padding-left: 0px !important;
}

.loigWrap{
  padding: 20px 0; float: left; width: 40%
}


@media (max-width: 800px) {
  .loigWrap {
    margin-top: 70px !important;
  }
}
@media (max-width: 1200px) {
  .loigWrap {
    margin-top: 70px !important;
  }
  .loigWrap /deep/ .el-upload-list {
    padding-left: 0px !important;
  }

  .logintitle {
    margin-top: -80px;

    width: 170px;
    text-align: left;
  }
}
@media (max-width: 1400px) {
  .logintitle {
    margin-top: 30px;

    width: 170px;
    text-align: left;
  }
  .loigWrap {
    margin-top: 20px;
  }
  .loigWrap /deep/ .picture-src {
    width: 180px;
    height: 140px !important;
  }
  .loigWrap /deep/ .picture {
    max-width: none;
    border-radius: 0;
    width: 180px;
    height: 140px;
    margin: 0px;
  }
  .loigWrap /deep/ .logTitle {
    width: 180px;
    text-align: center;
  }
}

.inputWrap{
  float: left; width: 60%
}
@media (max-width: 600px) {
  .loigWrap {
    /* margin-top: 70px !important; */
    width: 100%;
    height: auto;
    margin-top: 0px !important;
    padding: 0px;
  }
  .logintitle{
    /* margin-top: 0px; */
    margin: 0 auto;
  }
  .logTitle{
     margin: 0 auto;
  }
  .inputWrap{
     float: left;
     width: 100%
}

  .loigWrap .picture{
    width: 100%;
  }

  .loigWrap .picture-src{
    width: 100%;
       
  }
}

.picture-src {
  width: 340px;
  height: 190px !important;
}

.picture {
  max-width: none;
  border-radius: 0;
  width: 340px;
  height: 190px;
  margin: 0px;
}
.description {
  text-align: left;
}
.logTitle {
  width: 340px;
  text-align: center;
}


</style>